__turbopack_context__.v({
  "addButton": "G69Y8G_addButton",
  "addPill": "G69Y8G_addPill",
  "desktopOnly": "G69Y8G_desktopOnly",
  "divider": "G69Y8G_divider",
  "funds": "G69Y8G_funds",
  "fundsLabel": "G69Y8G_fundsLabel",
  "header": "G69Y8G_header",
  "headerDetails": "G69Y8G_headerDetails",
  "headerProfile": "G69Y8G_headerProfile",
  "headerProfileImg": "G69Y8G_headerProfileImg",
  "investorTag": "G69Y8G_investorTag",
  "location": "G69Y8G_location",
  "locationName": "G69Y8G_locationName",
  "moreTeamsButton": "G69Y8G_moreTeamsButton",
  "role": "G69Y8G_role",
  "roleAndLocation": "G69Y8G_roleAndLocation",
  "specificsHdr": "G69Y8G_specificsHdr",
  "specificsName": "G69Y8G_specificsName",
  "tagDivider": "G69Y8G_tagDivider",
  "tags": "G69Y8G_tags",
  "teamLink": "G69Y8G_teamLink",
  "teamLinkEmpty": "G69Y8G_teamLinkEmpty",
  "teams": "G69Y8G_teams",
  "teamsName": "G69Y8G_teamsName",
});
